import React, {useEffect} from "react";
import Api from "../../Services/Api";
import {Collapse, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { createTheme } from '@mui/material/styles';

import {isNumber} from "@mui/x-data-grid/utils/utils";

const SupplyFeedDetailsTable = ({supplyFeedId,demandFeedId, open, setOpen}) => {

    const [loading, setLoading] = React.useState(true);
    const [rows, setRows] = React.useState([]);
    const [totals, setTotals] = React.useState([]);
    const [flags, setFlags] = React.useState(false);

    const [rowColumns, setRowColumns] = React.useState([]);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const formatNumber = (value) => {
        if (isNaN(value) || value === null) return 0
        const valueFormatted = parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        maxWidth: "85%",
        overflow: "scroll",
        p: 4,
    };

    useEffect(() => {

        setLoading(true)
        setRows([])
        setRowColumns([])
        if (supplyFeedId && demandFeedId) {
            Api.supplyDemandDetails({supply_feed_id: supplyFeedId, demand_feed_id: demandFeedId}).then(r => {

                setRowColumns(r.columns)
                setRows(r.rows)
                setTotals(r.totals)
                setFlags(r.flags)
                setLoading(false)
            })
        }

    }, [supplyFeedId,demandFeedId, open])


    // const classes = createTheme({
    //     table: {
    //         minWidth: 650,
    //         fontSize: '200pt',
    //     },
    //     tablecell: {
    //         fontSize: '40pt',
    //     },
    //     sticky: {
    //         position: "sticky",
    //         left: 0,
    //         width: 180,
    //         minWidth: 180,
    //         background: "#abdbe3",
    //         boxShadow: "5px 2px 5px grey",
    //         borderRight: "2px solid black"
    //     }
    // });


    const checkCondition = (row, column) => {


        const types = ['ALL', 'BHS', 'N2S']

        const value = row[column] ? parseFloat(isNumber(row[column]) ? row[column]:row[column].replace(/,/g, '')) : 0


        for (let i = 0; i < types.length; i++) {

            if ((types[i] != "ALL" && row['demand_feed'] == null) || (types[i] != "ALL" && row['demand_feed'] && row['demand_feed'].type.name != types[i])) continue
            if (typeof flags[types[i]].red !== 'undefined' && typeof flags[types[i]].red[column] !== 'undefined') {
                let flagValue = flags[types[i]].red[column]['value']
                let condition = flags[types[i]].red[column]['condition']
                let passes = condition == "gt" ? value > flagValue : value < flagValue
                if (passes) return "#cc3300"
            }

            if (typeof flags[types[i]].yellow !== 'undefined' && typeof flags[types[i]].yellow[column] !== 'undefined') {

                let flagValue = flags[types[i]].yellow[column]['value']
                let condition = flags[types[i]].yellow[column]['condition']
                let passes = condition == "gt" ? value > flagValue : value < flagValue
                if (passes) return "#ffcc00"
            }
        }
        ;


    }


    return (

        <div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box >

                    {loading ? "loading data" : (rows.length) ?
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 300}} size="small" aria-label="simple table">
                                <TableHead>
                                    <TableRow >
                                        <TableCell sx={{
                                            backgroundColor: "black",
                                            color: "white",
                                            fontSize: '9pt'
                                        }} id='metrics' align="right" ></TableCell>
                                        {rows.map((column) => <TableCell sx={{
                                            backgroundColor: "black",
                                            color: "white",
                                            fontSize: '9pt'
                                        }} align="right" id={column['date']}>{column['date']}</TableCell>)}
                                        <TableCell sx={{
                                            backgroundColor: "black",
                                            color: "white",
                                            fontSize: '9pt'
                                        }} align="right" id="AVG">AVG</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rowColumns.map((column, i) => {
                                        return (column != "date" && column != "demand_feed" && column != "demand_feed_id" && column != "supply_feed_id" &&
                                            <TableRow >
                                                <TableCell sx={{
                                                    fontSize: '9pt'}}align="right" >{column}</TableCell>

                                                {rows.map((row, i) => <TableCell align="right"
                                                                                 sx={{background: checkCondition(row, column),
                                                                                     fontSize: '9pt'}}>{row[column] ?? "-"}</TableCell>)}
                                                <TableCell sx={{background: "grey", color: "white",
                                                    fontSize: '9pt'}}
                                                           x={{background: "black", color: "white",
                                                               fontSize: '9pt'}}
                                                           align="right">{totals.avg[column] ?? "-"}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>:"No Data"}
                </Box>
            </Modal>
        </div>)


}

export default SupplyFeedDetailsTable